import { Injectable } from '@angular/core';
import { DeviceDefinitionModel } from '../deviceDefinition.model';
import { DeviceDefinitionSummaryConverter } from './deviceDefinitionSummary.converter';
import {LovValueSummaryConverter} from "../../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter";
import {HttpModelConverter} from "../../../../../../core/converter/httpModel.converter";

@Injectable({
  providedIn: 'root'
})
export class DeviceDefinitionConverter extends HttpModelConverter<DeviceDefinitionModel> {
  constructor(private summaryConverter: DeviceDefinitionSummaryConverter,
              private lovValueSummaryConverter: LovValueSummaryConverter) {
    super();
  }

  protected createInstance(): DeviceDefinitionModel {
    return new DeviceDefinitionModel();
  }

  protected enrichObject(result: DeviceDefinitionModel, src: DeviceDefinitionModel) {
    result.summary = this.summaryConverter.convert(src.summary);
    result.manufacturer = this.lovValueSummaryConverter.convert(result.manufacturer);
  }
}

